export default __webpack_public_path__ + "static/media/compiegne15.696feffc.jpg";